module.exports = __webpack_public_path__ + "img/Villa_Borna_61.10e73c16.jpg";